import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

interface ExportToCsvButtonProps {
  handleExportToCsv: () => void | Promise<unknown>;
}

export default function ExportToCsvButton({
  handleExportToCsv,
}: ExportToCsvButtonProps) {
  const { t } = useTranslation('esg');
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      await handleExportToCsv();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="outlined"
      onClick={handleClick}
      disabled={isLoading}
      disableRipple
      startIcon={
        isLoading ? (
          <CircularProgress size={20} />
        ) : (
          <FileDownloadOutlinedIcon />
        )
      }
    >
      {t('dma.exportToCsv')}
    </Button>
  );
}
